import React from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { WeekPickerProps } from '@ecosystem/newron-design-system/build/components/datePicker/weekPicker/WeekPicker';
import { WeekPickerParams } from '../types';
const { WeekPicker, WeekFormatType } = inputs;

interface CustomWeekPickerProps {
  defaultStartDate: WeekPickerProps['defaultDate'];
  defaultEndDate: WeekPickerProps['defaultDate'];
  minDate: WeekPickerProps['minDate'];
  maxDate: WeekPickerProps['maxDate'];
  onChange: (type: 'from' | 'to', index: number) => (param: WeekPickerParams) => void;
  index: number;
}
export const CustomWeekPicker: React.FC<CustomWeekPickerProps> = ({
  defaultStartDate,
  defaultEndDate,
  minDate,
  maxDate,
  onChange,
  index,
}: CustomWeekPickerProps) => {
  const fromOnChangeFn = onChange('from', index);
  const toOnChangeFn = onChange('to', index);
  return (
    <>
      <div>
        <WeekPicker
          label={'Start date'}
          dateFormat={WeekFormatType['Ww yyyy']}
          defaultDate={defaultStartDate}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value: string) => fromOnChangeFn({ value })}
          name="start-date"
        />
      </div>
      <div>
        <WeekPicker
          label={'End date'}
          dateFormat={WeekFormatType['Ww yyyy']}
          defaultDate={defaultEndDate}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value: string) => toOnChangeFn({ value })}
          name="end-date"
        />
      </div>
    </>
  );
};
